module.exports = __webpack_public_path__ + "static/media/MAERSK.86431a03.svg";